/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseServiceUrl } from '../base-service-url';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getLuxAverageByFacilityAndDate } from '../fn/io-t-events/get-lux-average-by-facility-and-date';
import { GetLuxAverageByFacilityAndDate$Params } from '../fn/io-t-events/get-lux-average-by-facility-and-date';
import { getWaterConsumptionDataByFacilityAndDate } from '../fn/io-t-events/get-water-consumption-data-by-facility-and-date';
import { GetWaterConsumptionDataByFacilityAndDate$Params } from '../fn/io-t-events/get-water-consumption-data-by-facility-and-date';
import { LuxAverageFullResponse } from '../models/lux-average-full-response';
import { WaterConsumptionFullResponse } from '../models/water-consumption-full-response';

@Injectable({ providedIn: 'root' })
export class IoTEventsService extends BaseServiceUrl {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getLuxAverageByFacilityAndDate()` */
  static readonly GetLuxAverageByFacilityAndDatePath = '/api/iot-events/lux-average';

  /**
   * Get Lux Average By Facility And Date.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getLuxAverageByFacilityAndDate()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLuxAverageByFacilityAndDate$Response(params: GetLuxAverageByFacilityAndDate$Params, context?: HttpContext): Observable<StrictHttpResponse<LuxAverageFullResponse>> {
    return getLuxAverageByFacilityAndDate(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Lux Average By Facility And Date.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getLuxAverageByFacilityAndDate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getLuxAverageByFacilityAndDate(params: GetLuxAverageByFacilityAndDate$Params, context?: HttpContext): Observable<LuxAverageFullResponse> {
    return this.getLuxAverageByFacilityAndDate$Response(params, context).pipe(
      map((r: StrictHttpResponse<LuxAverageFullResponse>): LuxAverageFullResponse => r.body)
    );
  }

  /** Path part for operation `getWaterConsumptionDataByFacilityAndDate()` */
  static readonly GetWaterConsumptionDataByFacilityAndDatePath = '/api/iot-events/water-consumption';

  /**
   * Get Water Consumption Data By Facility And Date.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWaterConsumptionDataByFacilityAndDate()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWaterConsumptionDataByFacilityAndDate$Response(params: GetWaterConsumptionDataByFacilityAndDate$Params, context?: HttpContext): Observable<StrictHttpResponse<WaterConsumptionFullResponse>> {
    return getWaterConsumptionDataByFacilityAndDate(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Water Consumption Data By Facility And Date.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getWaterConsumptionDataByFacilityAndDate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWaterConsumptionDataByFacilityAndDate(params: GetWaterConsumptionDataByFacilityAndDate$Params, context?: HttpContext): Observable<WaterConsumptionFullResponse> {
    return this.getWaterConsumptionDataByFacilityAndDate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WaterConsumptionFullResponse>): WaterConsumptionFullResponse => r.body)
    );
  }

}
